import { useState, useEffect, useCallback, useRef } from "react";
import { handleInput, handleButtonClick, Message } from "./utils";
import { fetchInitQuestions } from "../../../../services/messageService";
import { logDebug, logTrace } from "../../../../utils/logger";
import {followUpQuestions} from "../../../../utils";
import {useAppContext} from '../../../../AppDataContext';

export const ChatData = ({
    policiesNotAllow,
    setVersions,
    userId,
    userClass,
    client_id,
    client_token,
    startNewChat,
    badgeurl,
    article_index,
    follow_up_question,
    proxy,
    welcome_message,
    follow_up_questions
}: {
    userId: string;
    userClass: string;
    client_id: string;
    policiesNotAllow: boolean;
    setVersions: React.Dispatch<React.SetStateAction<boolean>>;
    client_token: string;
    messages: Message[];
    setMessages: React.Dispatch<React.SetStateAction<Message[]>>;
    startNewChat: () => void;
    badgeurl?: string;
    article_index?: string;
    follow_up_question?: string;
    proxy?: string;
    welcome_message?: string;
    stopStreaming?: () => void;
    follow_up_questions?:any;
}) => {
    const dataContext = useAppContext();
    const [messages, setMessages] = useState<Message[]>([]);
    const [load, setLoad] = useState<boolean>(false);
    const [userInput, setUserInput] = useState<string>("");
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [fetchData, setFetchData] = useState<boolean>(true);
    const [stopStreaming, setStopStreaming] = useState<boolean>(false);
    const [childrenHeight, setChildrenHeight] = useState(1);
    const [justify, setJustify] = useState("center");
    const [error1, setError1] = useState(false);
    const [error2, setError2] = useState(false);
    const [error3, setError3] = useState("");
    const inputRef = useRef<HTMLTextAreaElement | null>(null);
    const [isDesktopScreen, setIsDesktopScreen] = useState(window.innerWidth > 744);
    const autoScrollEnabled = useRef(0);
    const [isPress, setIsPress] = useState<boolean>(false);
    const abortControllerRef = useRef(new AbortController());
    const [InitQuestions, setInitQuestions] = useState(false);
    // const [dotCount, setDotCount] = useState(0);
    const [isStreaming, setIsStreaming] = useState(false);
    const [policiesAccepted, setPoliciesAccepted] = useState(false);
    const [fakeVerbos, setFakeVerbos] = useState("");
    const alwaysShowVerbos = true;
    const isFirstTime = alwaysShowVerbos || !sessionStorage.getItem("hasSeenVerbos");

    // -----------------------------
    // 3) Fake Verbos Experience for first-time users.
    // -----------------------------
    useEffect(() => {
    if (load && isFirstTime) {
      const verbosSteps = [
        ["🔍 Thinking about that...", "🧐 Let me check...", "📡 Pulling up relevant info...", "⏳ One moment... processing..."],
        ["📡 Gathering key details...", "🛠️ Breaking it down...", "🔬 Checking sources...", "📚 Reviewing data..."],
        ["💭 Weighing different possibilities...", "📊 Evaluating potential responses...", "🧠 Mapping out the best approach...", "🔄 Considering multiple agents..."],
        ["🤖 Running a quick analysis...", "🔍 Checking for deeper insights...", "📈 Looking for key takeaways...", "💡 Making sure it's accurate..."],
        ["📊 Evaluating the key points...", "🛠️ Filtering out unnecessary noise...", "📜 Structuring a clear response...", "🎯 Making it concise and actionable..."],
        ["⚙️ Refining the response...", "📏 Fine-tuning for clarity...", "🔄 Making it easy to understand...", "✅ Ensuring logical flow..."],
        ["📜 Giving it one last polish...", "🔍 Checking for completeness...", "📢 Making sure it's user-friendly...", "📝 Wrapping up the main points..."],
        ["🛠️ Adjusting for clarity...", "📊 Double-checking relevance...", "🤖 Running a final pass...", "⚡ Ensuring it's to the point..."],
        ["⌛ Wrapping it up...", "🎯 Getting it ready for you...", "🚦 Almost there! Just a sec...", "🔄 Preparing to send..."],
        ["🚀 Ready!", "🎤 Here we go...", "📢 All set! Here’s what I found...", "📝 Done! Here’s your answer..."]
      ];
      (async function runVerbos() {
          let firstVerbosDisplay:boolean = true;
        for (let i = 0; i < verbosSteps.length; i++) {
          if (!load) break;
          // Use minimal delay when tab is hidden
          let normalDelay = Math.random() * 3000 + 2000
            if( i === 0 && firstVerbosDisplay) {
                normalDelay = Math.random() * 500;
                firstVerbosDisplay = false;
            }

          const delay = document.hidden ? 0 : normalDelay;
          await new Promise(res => setTimeout(res, delay));
          if (!load) break;
          const stepMessages = verbosSteps[i];
          const randomIndex = Math.floor(Math.random() * stepMessages.length);
          const selected = stepMessages[randomIndex];
          setFakeVerbos(selected)   ;
        }
      })();
    }
  }, [load, isFirstTime]);
    const paramsWrapForStatistics = {
        "user_id": userId,
        "client_id": client_id,
        "article_index": dataContext.article_index,
        "follow_up_question": dataContext.follow_up_question,
        "client_token": client_token,
        "proxy": proxy
    };

    useEffect(() => {
        if (!dataContext.follow_up_question) {
            const _welcomeMessage = dataContext.welcome_message;
            if (dataContext.welcome_message) {
                const TYPING_SPEED = 7;
                let currentText = '';
                let charIndex = 0;
                setMessages((prevMessages) => [
                    ...prevMessages,
                    {id:0, type: "bot", text: "" }
                ]);
                const typeNextChar = () => {
                    currentText += _welcomeMessage[charIndex];
                    charIndex += 1;
                    setMessages((prevMessages) => {
                        const updatedMessages = [...prevMessages];
                        updatedMessages[updatedMessages.length - 1] = {id:0, type: "bot", text: currentText };
                        return updatedMessages;
                    });
                    if (charIndex < _welcomeMessage.length) {
                        setTimeout(typeNextChar, TYPING_SPEED);
                    }
                };
                typeNextChar();
            } else {
                if(load)
                    return
                const _fetchInitQuestions = async () => {
                    return await fetchInitQuestions(proxy, client_token, client_id, userId,null,dataContext.language_for_chat,null,null,null);
                };
                setInitQuestions(true);
                _fetchInitQuestions().then((startQuestionsText) => {
                    const initialQuestions: any = startQuestionsText;
                    setMessages((prevMessages) => [...prevMessages, initialQuestions]);
                });
            }
        }
        dataContext.welcome_message = "";
    }, [setMessages]);

    useEffect(() => {
        const handleResize = () => {
            setIsDesktopScreen(window.innerWidth > 744);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const listRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (listRef.current && childrenHeight) {
            if (listRef.current.offsetHeight < childrenHeight && policiesNotAllow)
                setJustify("flex-start");
            else if (!policiesNotAllow)
                setJustify("flex-start");
        }
    }, [childrenHeight, policiesNotAllow]);

    useEffect(() => {
        if (autoScrollEnabled.current < 10 && listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
        }
    }, [messages, load]);

    const handleAutoScroll = useCallback(() => {
        if (autoScrollEnabled.current === 0 && listRef.current) {
            listRef.current.scrollTop = listRef.current.scrollHeight;
        }
    }, [messages]);

    useEffect(() => {
        if ((policiesAccepted || !policiesNotAllow) && dataContext.follow_up_question) {
              handleButtonClick(
                dataContext.follow_up_question,
                setMessages,
                setLoad,
                messages,
                setFetchData,
                () => setFetchData(false),
                setError1,
                setError2,
                setError3,
                userId,
                userClass,
                client_id,
                client_token,
                dataContext.article_index,
                proxy,
                statistics_logic,
                dataContext.language_for_chat || "EN",
                dataContext
            );
        }
    }, [policiesAccepted, policiesNotAllow, dataContext.follow_up_question]);

    const statistics_logic =
        dataContext.follow_up_question && dataContext.article_index ?
            { 'ARTICLE_WIDGET_ACTIVATION_SENT': 1, 'article_index': dataContext.article_index } :
            (dataContext.follow_up_question ?
                { 'ASSET_WIDGET_ACTIVATION_SENT': 1 }
                : { 'CONVERSATION_MESSAGE_SENT': 1 });

    const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement, UIEvent>) => {
        if (load) {
            const { clientHeight, scrollHeight, scrollTop } = (e.target as HTMLElement);
            if (scrollTop !== scrollHeight - clientHeight) {
                if (autoScrollEnabled.current < 10) {
                    autoScrollEnabled.current += 1;
                }
            } else {
                autoScrollEnabled.current = 0;
            }
        }
    }, [load]);

    const onInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setUserInput(e.target.value);
    };

    const resetUserInput = () => {
        setUserInput("");
    };

    const regenerateResponse = () => {
        let newMessages = [...messages];
        let userMessage = "";
        if (messages.length && error1 && messages.length > 1) {
            userMessage = messages[messages.length - 2].text;
            newMessages.pop();
            newMessages.pop();
            setMessages(newMessages);
        }
        if (messages.length && error2 && messages.length > 0) {
            logDebug("Error2 occurred, regenerating response...");
            userMessage = messages[messages.length - 1].text;
            newMessages.pop();
            setMessages(newMessages);
        }
        if (messages.length && error3 && messages.length > 0) {
            startNewChat();
            setError3("");
        }
        if (userMessage) {
             handleButtonClick(
                userMessage,
                setMessages,
                setLoad,
                newMessages,
                setFetchData,
                setStopStreaming,
                setError1,
                setError2,
                setError3,
                userId,
                userClass,
                client_id,
                client_token,
                article_index,
                proxy,
                statistics_logic,
                dataContext.language_for_chat || "EN",
                dataContext
            );
        }
    };
        const sendQuestion = useCallback((questionText: string) => {
        setShowInitialQuestions(false);
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
            abortControllerRef.current = new AbortController();
            setIsPress(true);
             handleButtonClick(
                questionText,
                setMessages,
                setLoad,
                messages,
                setFetchData,
                setStopStreaming,
                setError1,
                setError2,
                setError3,
                userId,
                userClass,
                client_id,
                client_token,
                article_index,
                proxy,
                statistics_logic,
                dataContext.language_for_chat || "EN",
                dataContext
            ).finally(() => {
                setIsPress(false);
                logDebug("Timeout occurred, request aborted.");
            });
    }, [messages, userId, client_id]);

    const abortAll = useCallback(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    }, []);

    const StopButton = () => (
        <button onClick={abortAll}>Stop</button>
    );

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (!load && event.key === 'Enter' && document.activeElement !== inputRef.current) {
                regenerateResponse();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [messages, load, fetchData]);

    const [showInitialQuestions, setShowInitialQuestions] = useState(true);

    useEffect(() => {
        if (messages.length > 1) {
            setShowInitialQuestions(false);
        }
    }, [messages]);

    return {
        messages,
        setMessages,
        load,
        setLoad,
        userInput,
        setUserInput,
        currentIndex,
        setCurrentIndex,
        fetchData,
        setFetchData,
        // streamingText,
        // setStreamingText,
        childrenHeight,
        setChildrenHeight,
        justify,
        setJustify,
        error1,
        setError1,
        error2,
        setError2,
        error3,
        setError3,
        inputRef,
        isDesktopScreen,
        setIsDesktopScreen,
        autoScrollEnabled,
        isPress,
        setIsPress,
        abortControllerRef,
        InitQuestions,
        setInitQuestions,
        fakeVerbos,
        setFakeVerbos,
        isStreaming,
        setIsStreaming,
        policiesAccepted,
        setPoliciesAccepted,
        paramsWrapForStatistics,
        listRef,
        handleAutoScroll,
        handleScroll,
        onInputChange,
        resetUserInput,
        regenerateResponse,
        sendQuestion,
        StopButton,
        showInitialQuestions,
        setShowInitialQuestions,
        statistics_logic,
        welcome_message,
        follow_up_questions,
        isFirstTime
    };
};
